export const defaultFormatChars = {
  '9': /[0-9]/,
  a: /[A-Za-zА-Яа-я]/,
  '*': /[A-Za-zА-Яа-я0-9]/
};